import meditationCategoriesList from './actions/meditationCategoriesList';
import meditationCategoryChange from './actions/meditationCategoryChange';
import meditationCategoryCreate from './actions/meditationCategoryCreate';
import meditationCategoryDetail from './actions/meditationCategoryDetail';
import getMeditationCategories from './getters/getMeditationCategories';
import meditationCategoriesUpload from './mutations/meditationCategoriesUpload';

const actions = {
    meditationCategoryChange,
    meditationCategoryCreate,
    meditationCategoryDetail,
    meditationCategoriesList
};

const mutations = {
    meditationCategoriesUpload
};

const getters = {
    getMeditationCategories
};

export default { actions, mutations, getters };
